import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useFormConfigContext } from "../../../common/contexts/FormConfigContext";
import isInboundFromNbly from "../../../utility/checkInBoundFromNbly";

interface PaymentErrorModalProps {
  paymentFailureMessage: string;
  paymentBtnLabel: string;
}

const PaymentErrorModal = ({
  paymentFailureMessage,
  paymentBtnLabel,
}: PaymentErrorModalProps) => {
  const { formConfig } = useFormConfigContext();
  const redirectToConfirmation = () => {
    if (isInboundFromNbly()) {
      globalThis.location.replace(
        `${formConfig?.redirectionPageUrl}?leadconcept=${formConfig?.conceptCode}`
      );
      return;
    }
    globalThis.location.replace(formConfig?.redirectionPageUrl);
  };
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={true}
      data-testid="error-modal"
    >
      <DialogContent className="payement-error-content">
        <Typography
          className="error-pricing-text"
          align="center"
          data-testid="error-modal-text"
        >
          {paymentFailureMessage}
        </Typography>
      </DialogContent>

      <DialogActions
        className="payment-error-actions"
        sx={{ justifyContent: "center" }}
      >
        <Button
          autoFocus
          className="payment-error-btn"
          data-testid="close-button"
          onClick={redirectToConfirmation}
        >
          {paymentBtnLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentErrorModal;
